import { RootState } from '../index';

const getSelectedArticle = (state: RootState) => state.helpReducer.selectedArticle;

const getIsOpenFeedbackNav = (state: RootState) => state.helpReducer.isOpenFeedbackNav;

const getIsOpenDiscordNav = (state: RootState) => state.helpReducer.isOpenDiscordNav;

const getSearchArticle = (state: RootState) => state.helpReducer.searchArticle;

export {
  getSelectedArticle,
  getIsOpenFeedbackNav,
  getSearchArticle,
  getIsOpenDiscordNav,
};
